import { CreateListingAsyncActions } from 'store/actions/createListing';
import { createReducerFromActions } from 'utils/store';
import { values } from 'lodash';

export default createReducerFromActions(...values(CreateListingAsyncActions));
